export enum ErrorMessages {
    NAME_REQUIRED = "*Firstname is a required field.",
    SURNAME_REQUIRED = "*Surname is a required field.",
    EMAIL_REQUIRED = "*Email address is a required field.",
    UNIVERSITY_REQUIRED = "*University is a required field.",
    FACULTY_REQUIRED = "*Faculty is a required field.",
    DEPARTMENT_REQUIRED = "*Department is a required field.",
    INVALID_EMAIL = "*Please enter a valid email address.",
    FAC_DEPT_MISMATCH = "*Department and Faculty does not match.",
    RANK_REQUIRED = "*Rank is a required field.",
    MINIMUM_AMOUNT_REQUIRED = "*Amount must be greater than ",
    AMOUNT_REQUIRED = "*Amount is required",
    MAXIMUM_AMOUNT_REQUIRED = "*Amount must be less than or equal to ",
    REASON_REQUIRED = "Reason is required when requesting this change",
    ALLOCATION_AMOUNT_EXCEEDED = "*Amount exceeds the remaining bursary allocation for this university."
}